
import * as React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@/components/theme-provider";
import Loading from "./components/layout/Loading";
import { applyGlobalDialogFix } from "./utils/dialog-fix";
import { ErrorBoundary } from "./components/ErrorBoundary";

// Aplicar fix global para diálogos
applyGlobalDialogFix();

// Create the ErrorBoundary component
class FallbackUI extends React.Component {
  render() {
    return (
      <div className="flex flex-col items-center justify-center h-screen p-4 text-center">
        <h2 className="text-2xl font-bold mb-4">Algo salió mal</h2>
        <p className="mb-4">Estamos trabajando para solucionarlo</p>
        <button 
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          onClick={() => window.location.reload()}
        >
          Reintentar
        </button>
      </div>
    );
  }
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={FallbackUI}>
      <ThemeProvider defaultTheme="light" storageKey="theme">
        <React.Suspense fallback={<Loading />}>
          <App />
        </React.Suspense>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
